/* eslint-disable */
import { Config } from 'src/common/config/Config'
import i18n from 'src/i18n'

import { HttpCode } from '../constants'
import { getLocalItem } from '../utils/OfflineManager'
import { snackbarUtils, SnackbarMessage } from '../utils'

class ClientBase {
  authToken = ''

  public constructor() {
    this.authToken = (
      getLocalItem('okta-token-storage') as any
    ).accessToken.accessToken
  }

  protected getBaseUrl(arg0: string, baseUrl: string): string {
    return Config.api.host
  }

  protected setAuthToken(token: string) {
    this.authToken = token
  }

  protected transformOptions(options: any): Promise<any> {
    if (!options?.headers) {
      options.headers = new Headers()
    }

    // We do not use the If-Match header and it is not allowed by our CORS policy so we need to remove if
    if (options.headers['If-Match']) {
      delete options.headers['If-Match']
    }

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${this.authToken}`,
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': i18n.language,
    }

    return Promise.resolve(options)
  }

  protected async transformResult(
    url_: string,
    _response: Response,
    actionResult: any
  ) {
    // We need to clone the request because you are only allowed to read it once. We need to read it a second time to get the correct metadata and typings.
    const requestClone = _response.clone()

    try {
      // filter out codes with no response JSON body
      switch (_response.status) {
        // used both for creation and updates (alas!)
        case HttpCode.CREATED:
          snackbarUtils.success(i18n.t('common.statusCodes.success'))
          break
        case HttpCode.NOT_FOUND:
          // Since the request with the statuscode 204 does not contain a body we can return undefined
          snackbarUtils.warning(i18n.t('common.statusCodes.notFound'))
          return Promise.resolve(null)
        case HttpCode.NO_CONTENT:
          snackbarUtils.success(i18n.t('common.statusCodes.success'))
          return Promise.resolve(undefined)
        case HttpCode.FORBIDDEN:
          snackbarUtils.warning(
            i18n.t('common.statusCodes.code', { code: _response.status })
          )
          return Promise.resolve(undefined)
        default:
          break
      }

      const clientResult = await actionResult(_response)
      const result = await requestClone.json()
      return {
        ...result,
        cleanedResponse: clientResult,
      }
    } catch (error: any) {
      if (_response.status === HttpCode.CREATED)
        return Promise.resolve(undefined)
      const requestError = await requestClone.json()

      if (requestError.errors) {
        for (const [key, value] of Object.entries(requestError.errors)) {
          if(!value){
            snackbarUtils.error(key)
          } else if (typeof value === 'string'){
            snackbarUtils.error(`${key}: ${value}`)
          } else {
            snackbarUtils.error(SnackbarMessage(Object.values(value), key))
          }
        }
      } else if (requestError.value) {
        snackbarUtils.error(requestError.value)
      } else if (requestError.status) {
        snackbarUtils.error(
          i18n.t('common.statusCodes.code', { code: `${requestError.status}` })
        )
      } else {
        snackbarUtils.error(i18n.t('common.genericError'))
      }
      return Promise.resolve(undefined)
    }
  }
}

export default ClientBase
